// Parse timestamps as UTC — server stores UTC without 'Z' suffix
function parseUTC(dateStr: string): Date {
  // If already has timezone info, use as-is
  if (dateStr.includes('Z') || dateStr.includes('+') || dateStr.includes('T')) {
    return new Date(dateStr)
  }
  // Assume UTC — append Z
  return new Date(dateStr.replace(' ', 'T') + 'Z')
}

export function timeAgo(dateStr: string): string {
  const date = parseUTC(dateStr)
  const now = Date.now()
  const diff = now - date.getTime()
  const secs = Math.floor(diff / 1000)
  if (secs < 60) return 'just now'
  const mins = Math.floor(secs / 60)
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `${hrs}h ago`
  const days = Math.floor(hrs / 24)
  if (days < 7) return `${days}d ago`
  return date.toLocaleDateString()
}

// Format absolute timestamp in local timezone
export function formatTimestamp(dateStr: string): string {
  return parseUTC(dateStr).toLocaleString()
}

export function formatTime(dateStr: string): string {
  return parseUTC(dateStr).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/New_York',
  })
}
